export default {
  'YouTube and High Definition Videos': 'YouTube和高畫質影片',
  'Story videos (Instagram/Snaps/TikTok)': '即時動態影片（Instagram/Snaps/TikTok）',
  'Facebook and Instagram Feed videos': 'Facebook和Instagram動態消息影片',
  'Facebook and Twitter Portrait Videos': 'Facebook and Twitter 垂直式影片',
  'Twitter and Facebbok Landscape Videos': 'Facebook and Twitter 水平式影片',
  'Facebook Cover Videos And Blog Banners': 'Facebook 封面影片和部落格橫幅',
  'Fit': '適應',
  'Fill': '填充',
}